module.exports = __webpack_public_path__ + "media/images/flags/32/Central-African-Republic-0dcc5c407c03143ac1fbdcc8428f591c.png";